import React from 'react';
import styled from 'styled-components';

import {CHETWODEBLUE, OzCard} from "@ozwol/webui";

const Text = styled.div`
  color: ${CHETWODEBLUE};
  background: ${CHETWODEBLUE}13;
  padding: 30px;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
`;

const ModalSuccess = ({children}) => {
  return (
    <OzCard>
      {children ? 
        <Text>
          {children}
        </Text>
      : null }
    </OzCard>  
  )

}

export default ModalSuccess;
